import React, { useState, useEffect, useCallback, useRef } from "react";
import Select from "react-select";
import { useParams } from "react-router-dom";
// import { DynamicReports } from "./DynamicReports";
import axios from "../axios";
import ChangeIcon from "./../Assets/images/change-icon.png";
import "../Assets/styles/newStyles/LabelReadMode.css";
import ClipLoader from "react-spinners/ClipLoader";
import RemoveRectangle from '../Assets/images/remove-rectangle.svg'

export const LabelReadMode = (props) => {
  const {
    readModeData,
    index,
    isEditMode,
    editMode,
    customStyles,
    diseaseOptions,
    isOptionDisabled,
    coughOptions,
    patternOptions,
    severityOptions,
    anatomyOptions,
    labelTypeOptions,
    recordId,
    editLabelData,
    getPatientRecords1,
  } = props;

  const [editedDiseaseOptions, setEditedDiseases] = React.useState([]);
  const [editedCoughOptions, setEditedCough] = React.useState([]);
  const [editedPatternOptions, setEditedPattern] = React.useState([]);
  const [editedSeverityOption, setEditedSeverity] = React.useState([]);
  const [editedAnatomyOptions, setEditedAnatomy] = React.useState([]);
  const [editedLabelTypeOption, setEditedLabelType] = React.useState([]);
  const [editedComment, setEditedComment] = React.useState("");
  const [isLabelTypeRequired, setIsLabelTypeRequired]= useState(false)
  const [isLoading, setIsLoading] = React.useState(false);


  console.log(readModeData.severityType);
  console.log(severityOptions)


  useEffect(() => {
 

    try {
      
     
      setEditedDiseases(
        diseaseOptions.filter((option) =>
          readModeData.DiseaseType.split(",").includes(option.value)
        )
      );
      setEditedCough(
        coughOptions.filter((option) =>
          readModeData.coughType.split(",").includes(option.value)
        )
      );
      setEditedPattern(
        patternOptions.filter((option) =>
          readModeData.patternType.split(",").includes(option.value)
        )
      );
      setEditedSeverity(
        severityOptions.filter(
          (option) => option.value == readModeData.severityType
        ) 
      );
      setEditedAnatomy(
        anatomyOptions.filter((option) =>
          readModeData.anatomyType.split(",").includes(option.value)
        )
      );
      setEditedLabelType(
        labelTypeOptions.filter(
          (option) => option.value == readModeData.labelType
        )
      );
      setEditedComment(readModeData.comments);
    } catch (e) {
      
      console.log(e);
    }
  }, []);

  console.log(editedSeverityOption)
  console.log(editedLabelTypeOption)

  const changeMode = (index) => {
    isEditMode(index);
  };

 

  // edit change methods

  const editDisease = (editedDiseaseOptions) => {
    console.log("click");
    setEditedDiseases(editedDiseaseOptions);
  };

  const editCough = (editedCoughOptions) => {
    console.log("click");
    setEditedCough(editedCoughOptions);
  };

  const editPattern = (editedPatternOptions) => {
    console.log("click");
    setEditedPattern(editedPatternOptions);
  };

  const editSeverity = (editedSeverityOption) => {
    
    console.log("click");
    setEditedSeverity([editedSeverityOption]);
    
  };

  const editAnatomy = (editedAnatomyOptions) => {
    console.log("click");
    setEditedAnatomy(editedAnatomyOptions);
  };

  const editLabelType = (editedLabelTypeOption) => {
    setEditedLabelType([editedLabelTypeOption]);
    setIsLabelTypeRequired(false)
  };

  const params = useParams();

  const editLabel = (index) => {

    if (!editedLabelTypeOption|| editedLabelTypeOption.length === 0) {
      setIsLabelTypeRequired(true)
      return;
    }
   
    
    const formattedCough = editedCoughOptions
      .map((option) => option.value)
      .join(",");
    const formattedDisease = editedDiseaseOptions
      .map((option) => option.value)
      .join(",");
    const formattedPattern = editedPatternOptions
      .map((option) => option.value)
      .join(",");
    const formattedAnatomy = editedAnatomyOptions
      .map((option) => option.value)
      .join(",");
    console.log(editedSeverityOption,"sev");
    const severityType =  editedSeverityOption.length ===0 ? '' : editedSeverityOption[0].value
    const labelType = editedLabelTypeOption.length ===0 ? '' : editedLabelTypeOption[0].value
    console.log(labelType)

    const labelData = {
      recordId: recordId || "",
      fileName: editLabelData[index].fileName,
      data: {
        patternType: formattedPattern,
        DiseaseType: formattedDisease,
        coughType: formattedCough,
        anatomyType: formattedAnatomy,
        severityType: severityType,
        comments: editedComment,
        labelType: labelType,
      },
      createdOn: editLabelData[index].createdOn,
      fileType: editLabelData[index].fileType,
    };


    setIsLoading(true)
   
    const formData = new FormData();

    formData.append("patient_id", decodeURIComponent(params.patientId) || "");
    formData.append("record_id", recordId || "");
    formData.append("labelData", JSON.stringify(labelData));
    formData.append("fileName", props.record?.recordId || "");
    formData.append("doctorId", params.doctorId || "");
    axios({
      method: "POST",
      url: "/updateRecordLabel",
      data: formData,
      headers: {
        accessToken: localStorage.accessToken,
      },
    })
      .then((response) => {
        setIsLoading(false)
        getPatientRecords1();
        changeMode(-1)
      })
      .catch((error) => {
        setIsLoading(false)
        console.log(error);
      });
  };

  console.log(editMode);
  const cancelEditLabel=()=>{
    changeMode(-1)
  }

  return (
    <>
      {editMode ? (
        <div>
          <div className="label-container">
            {/* <DynamicReports /> */}
            <div style={{display:'flex',justifyContent:'space-between',paddingBottom:'10px'}} >
              <p  className="read-mode-heading">Labelling Data #{index+1}</p>
              <div style={{display:'flex', flexDirection: 'row', alignItems: 'center'}} onClick={cancelEditLabel} >
              <p style={{cursor: 'pointer'}} className="cancel-btn" >Cancel</p>
              <img className="cancel-img" src={RemoveRectangle} alt='close'/>
              </div>
            </div>
            {/* <div>
              <p>delete</p>
              <img src={deleteICon} alt="" />
            </div> */}
            <h5 className="label-heading">Disease</h5>
            <Select
              options={diseaseOptions}
              value={editedDiseaseOptions}
              onChange={editDisease}
              isMulti={true}
              isOptionDisabled={isOptionDisabled}
              styles={customStyles}
              placeholder="Multiple Select"
            />
          </div>
          <div className="label-container">
            <h5 className="label-heading">Cough Type</h5>
            <Select
              options={coughOptions}
              value={editedCoughOptions}
              onChange={editCough}
              isMulti={true}
              isOptionDisabled={isOptionDisabled}
              styles={customStyles}
              placeholder="Multiple Select"
            />
          </div>
          <div className="label-container">
            <h5 className="label-heading">Pattern</h5>
            <Select
              options={patternOptions}
              value={editedPatternOptions}
              onChange={editPattern}
              isMulti={true}
              isOptionDisabled={isOptionDisabled}
              styles={customStyles}
              placeholder="Multiple Select"
            />
          </div>
          <div className="label-container">
            <h5 className="label-heading">Severity</h5>
          
            <Select
              options={severityOptions}
              value={editedSeverityOption}
              onChange={editSeverity}
              styles={customStyles}
              placeholder="Select"
            />
          </div>
          <div className="label-container">
            <h5 className="label-heading">Anatomy</h5>
            <Select
              options={anatomyOptions}
              value={editedAnatomyOptions}
              onChange={editAnatomy}
              isMulti={true}
              isOptionDisabled={isOptionDisabled}
              styles={customStyles}
              placeholder="Multiple Select"
            />
          </div>
          <div className="label-container">

            <h5 className="label-heading">Label Type</h5>
            <Select
              options={labelTypeOptions}
              value={editedLabelTypeOption}
              onChange={editLabelType}
              styles={customStyles}
              placeholder="Select"
              
            />
            {isLabelTypeRequired && <p className='label-error'>Please select label type</p>}
          </div>
          <div>
            <h5 className="label-heading">Comment</h5>
            <textarea
              placeholder="Type"
              value={editedComment}
              className="comment-textarea"
              onChange={(e) => setEditedComment(e.target.value)}
            ></textarea>
          </div>
          <div className="patient-report-feedback">
          {isLoading? <div
                                className="submit-feedback"
                                style={{
                                  textAlign: "center",
                                  paddingTop: "8px",
                                }}
                              >
                                <ClipLoader color="white" size={25} />
                              </div> :  <button
              className="submit-feedback"
              type="button"
              onClick={() => editLabel(index)}
            >
              Edit & Save Label
            </button>}
           
          </div>
        </div>
      ) : (
        <div className="read-mode-container">
          {readModeData && (
            <>
              <div className="read-mode-header">
                {/* <div style={{display: 'flex', flexDirection: 'row'}}> */}
                  <p className="read-mode-heading">Labelling Data #{index + 1}</p>
                {/* </div> */}
                <div
                  onClick={() => changeMode(index)}
                  style={{ display: "flex", alignItems: "center", gap: "6px" }}
                >
                  <p className="change-button">Change</p>
                  <img src={ChangeIcon} className="circle" alt="change" />
                </div>
              </div>
              <div className="read-mode-data-container">
                <div className="reportpdfs-container">
                  {/* {readModeData.pdfReports.map((each)=>     
                    <div key={each.id} style={{marginBottom:'12px'}} >
                    <p className='readmode-label-heading'>{each.label}</p>+
                    <a className='readmode-pdf-value'>{each.file}</a>
                </div>           
                )} */}
                </div>
                {/* <p className='label-vertical-line'></p>          */}
                <div>
                  <div style={{ marginBottom: "12px" }}>
                    <p className="readmode-label-heading">Disease</p>
                    <p className="readmode-value">{readModeData.DiseaseType}</p>
                  </div>
                  <div style={{ marginBottom: "12px" }}>
                    <p className="readmode-label-heading">Patttern</p>
                    <p className="readmode-value">{readModeData.patternType}</p>
                  </div>
                  <div style={{ marginBottom: "12px" }}>
                    <p className="readmode-label-heading">Anatomy</p>
                    <p className="readmode-value">{readModeData.anatomyType}</p>
                  </div>
                  <div style={{ marginBottom: "12px" }}>
                    <p className="readmode-label-heading">Comment</p>
                    <p className="readmode-value">{readModeData.comments}</p>
                  </div>
                </div>
                <div style={{ marginLeft: "20px" }}>
                  <div style={{ marginBottom: "12px" }}>
                    <p className="readmode-label-heading">Cough Type</p>
                    <p className="readmode-value">{readModeData.coughType}</p>
                  </div>
                  <div style={{ marginBottom: "12px" }}>
                    <p className="readmode-label-heading">Severity</p>
                    <p className="readmode-value">
                      {readModeData.severityType}
                    </p>
                  </div>
                  <div style={{ marginBottom: "12px" }}>
                    <p className="readmode-label-heading">Label Type</p>
                    <p className="readmode-value">{readModeData.labelType}</p>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
};